import React from 'react';
import t from 'modules/i18n/intl';
import { Field } from 'modules/form';
import BillingDetailsTaxIdRadio from './MACContactDetailsTaxIdRadio';
import { Dimensions } from 'components/visuals';
import { TaxFreeMessage } from 'modules/checkout/contacts/TaxIdInput';
import Textfield from '@atlaskit/textfield';
import { Country } from 'modules/data/countries/model';
import { TaxRate } from 'modules/data/taxRates/model';
import { ErrorMessage } from '@atlaskit/form';
import { FormattedMessage } from 'react-intl';

type TaxIdFieldProps = {
  country: Country | undefined;
  taxRate: TaxRate;
  showTaxId: boolean;
  taxIdLabel: string;
  vatResponsible: boolean | null;
  taxId: string;
  shouldShowVATResponsibilitySection?: boolean;
  handleFormChange: (e, fieldName) => void;
  setBillingDetailsForm: (value) => void;
  taxIdValidationResult: any;
};

export default ({
  taxRate,
  showTaxId,
  taxIdLabel,
  country,
  vatResponsible,
  taxId,
  handleFormChange,
  setBillingDetailsForm,
  taxIdValidationResult,
}: TaxIdFieldProps) => {
  const isCountryChile = country?.isoCountryCode === 'CL';
  const taxIdChilePlaceholder = isCountryChile ? 'XX.XXX.XXX-X' : '';
  const shouldShowTaasError =
    taxId && (taxIdValidationResult?.failed || taxIdValidationResult?._result?.failureEntity);

  return (
    <>
      <Field
        aria-required
        name="taxId"
        id="taxId"
        label={taxIdLabel}
        errorMessage={() => t('checkout.contact.enter-valid-taxid', { taxIdLabel })}
      >
        {({ fieldProps }) => (
          <Textfield
            {...fieldProps}
            isDisabled={!showTaxId || !taxRate}
            maxLength={100}
            onChange={(e) => handleFormChange(e, 'taxId')}
            value={taxId}
            data-cy="mac-billing-details-tax-id-input"
            width={Dimensions.units(50)}
            placeholder={taxIdChilePlaceholder}
          />
        )}
      </Field>
      {shouldShowTaasError && (
        <ErrorMessage>
          {taxIdValidationResult._result?.failureEntity?.errorDetail || (
            <FormattedMessage
              defaultMessage="Invalid Tax ID"
              id="mac.payment-details.billing-form.invalid.tax.id"
            />
          )}
        </ErrorMessage>
      )}
      {taxRate && showTaxId && (
        <>
          <TaxFreeMessage taxRate={taxRate} country={country} />
          {isCountryChile && (
            <Field
              name="vatResponsible"
              errorMessage={() => t('checkout.contact.tax-id-vat-error-message')}
            >
              {({ fieldProps }) => (
                <BillingDetailsTaxIdRadio
                  {...fieldProps}
                  vatResponsible={vatResponsible}
                  isTaxIdFieldEmpty={!taxId}
                  setBillingDetailsForm={setBillingDetailsForm}
                />
              )}
            </Field>
          )}
        </>
      )}
    </>
  );
};
